// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"ee49a7b1","321":"60e2d5b3"}[chunkId] + ".chunk.css";
};